import React from 'react';
import moment from 'moment';

import ReportHistoriesTable from './ReportHistoriesTable'

const ReportHistories = ({
  histories = [],
  resourceType = '',
  resourceId = null
}) => {

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3'>Report Histories of {resourceType} id {resourceId}</h3>
      </div>

      <ReportHistoriesTable histories={histories}/>
    </React.Fragment>
  );
}

export default ReportHistories
